import * as React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CircularProgress, Box, Fab, styled } from '@mui/material'
import { Typography as MIUTypography, Backdrop } from '@mui/material'
import { green } from '@mui/material/colors'
import CheckIcon from '@mui/icons-material/Check'
import SaveIcon from '@mui/icons-material/Save'
import { getAllLocations } from '../../services'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import * as RT from '../../config/routes'
import { detectCityFromURL } from '../../utils/cityDetector'
import { buildCantonUrl } from '../../utils/cantonUrl'
import { useCities } from '../../context/CitiesContext'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '1,2em',
  fontWeight: 601,
  lineHeight: '24px',
  color: '#fff',
}))

const SimpleBackdrop = ({ control = false, treeId, redirect = false, onSuccess, canton = null, tenant = null }, ref) => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  // Usar canton prop si se proporciona, sino detectar de la URL
  const currentCity = canton || detectCityFromURL(location.pathname) || 'loja'
  const { getEnabledCantones } = useCities()
  const cantones = getEnabledCantones()

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  }

  React.useImperativeHandle(ref, () => ({
    openAlert: value => setOpen(value),
    loading: value => setLoading(value),
    success: () => setSuccess(true),
  }))

  // Resetear estados cuando se cierra el Backdrop
  React.useEffect(() => {
    if (!open) {
      setSuccess(false)
      setLoading(false)
    }
  }, [open])

  React.useEffect(() => {
    if (control) return
    if (!open) return
    if (!loading) {
      setLoading(true)
      if (redirect) {
        setTimeout(() => {
          setSuccess(true)
          setLoading(false)
        }, 800)
      } else {
        getAllLocations(currentCity, tenant)
          .then(geojson => {
            if (!Object.keys(geojson).length)
              console.log('No se pudo cargar los datos. Intente más tarde.')
            else {
              dispatch(setFeature(geojson))
              setSuccess(true)
              setLoading(false)
            }
          })
          .catch(err => {
            console.warn('Error al obtener ubicaciones:>> ', err.message)
            setSuccess(true)
            setLoading(false)
          })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  React.useEffect(() => {
    if (!success) return

    setTimeout(() => {
      // Si hay callback, no navegar - dejar que el callback maneje todo
      if (onSuccess) {
        onSuccess()
      } else {
        // Sin callback, navegar normalmente
        if (redirect) {
          navigate(0, { replace: true })
        } else {
          navigate(buildCantonUrl(currentCity, cantones, `${RT.MANAGEMENT}/${treeId}`), { replace: true })
        }
      }
    }, 800)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success])

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      open={open}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ position: 'relative' }}>
          <Fab aria-label="save" color="primary" sx={buttonSx}>
            {success ? <CheckIcon /> : <SaveIcon />}
          </Fab>
          {loading && (
            <CircularProgress
              size={68}
              sx={{
                color: green[500],
                position: 'absolute',
                top: -6,
                left: 15,
                zIndex: 1,
              }}
            />
          )}
          <Box sx={{ pt: 3 }}>
            {!success ? (
              <Typography>Guardando...</Typography>
            ) : (
              <Typography>¡Guardado correctamente!</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Backdrop>
  )
}
export default React.forwardRef(SimpleBackdrop)
